// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page_chat {
    height: 100dvh; /* Altezza dinamica esatta per mobile */
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
    box-sizing: border-box !important;
}

/* Assicura che i contenitori intermedi riempiano lo spazio senza sforare */
.page_chat .filters-no-padding,
.page_chat .main-chat,
.page_chat .col-lg-12 {
    display: flex !important;
    flex-direction: column !important;
    flex: 1 1 !important;
    margin: 0 !important;
    padding: 0 !important;
    min-height: 0 !important; /* Forza il contenitore a non espandersi oltre il flex */
}

.page_chat .chat-box {
    position: relative !important; 
    width: 100%;
    background: #fff;
    border-top: 1px solid #ddd;
    padding: 10px 0;
    padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 15px) !important; /* Più spazio per la barra di sistema */
    margin-top: auto; 
    flex-shrink: 0 !important; /* Impedisce alla barra di restringersi */
}

.page_chat .chat-box .form-group {
    margin-bottom: 0 !important;
    padding: 0 5px;
}

.page_chat #messageForm .input-group {
    position: relative !important;
    display: flex !important;
    align-items: center !important;
}

.page_chat #messageForm #message {
    padding-left: 45px !important; /* Spazio per la graffetta */
    padding-right: 65px !important; /* Spazio per il tasto invia */
    border-radius: 25px !important; /* Forma a pillola stile WhatsApp */
    min-height: 45px !important;
    line-height: 20px !important;
    padding-top: 12px !important;
}

.page_chat .attach-button {
    position: absolute !important;
    left: 8px !important;
    z-index: 10;
    background: transparent !important;
    border: none !important;
    color: #666 !important;
    width: 35px !important;
    height: 35px !important;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 0 !important;
    transition: background 0.2s !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
}

.page_chat .attach-button:hover {
    background: rgba(0,0,0,0.05) !important;
    color: var(--primary) !important;
}

.page_chat .attach-button i {
    font-size: 18px !important;
}

.page_chat .chat_send_button {
    position: absolute !important;
    right: 8px !important;
    bottom: 5px !important;
    height: 35px !important;
    padding: 0 15px !important;
    border-radius: 20px !important;
    z-index: 10;
}

.page_chat #chatArea {
    flex: 1 1;
    overflow-y: auto;
    padding-bottom: 10px !important;
}

.page_chat .spacerMsg {
    height: 50px;
}

.page_chat .photo-placeholder,
.page_chat img {
    width: 300px;
    display: block;
}

.page_chat .chat-box {
  transition: all 0.2s ease;
}

.page_chat .chat-box.photo-mode .chat_send_button {
  padding: 6px 10px;
  font-size: 12px;
}

.page_chat .chat-box.photo-mode .input-group {
  display: flex !important;
  align-items: center !important;
  height: 40px !important;
}

.page_chat .chat-box.photo-mode .attach-button,
.page_chat .chat-box.photo-mode .input-group-append button {
  height: 26px !important; /* Adjusted from 20px */
  padding: 0 8px !important; /* Reduced from 0 10px */
  line-height: 26px !important; /* Updated to match height */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px !important; /* Added for rounded corners */
}

.page_chat .chat-box.photo-mode textarea {
  height: 26px !important;
  min-height: 26px !important;
  max-height: 26px !important;
  padding: 2px 6px !important;
  font-size: 11px;
  resize: none !important;
  overflow: hidden;
}

.page_chat .chat-box.photo-mode .input-group > * {
  align-self: center;
}


/* Overlay immagine preview */
.page_chat .photoOverlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,0.85);
    z-index: 10000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1rem;
}

/* Pulsante chiusura preview */
.page_chat .photoOverlayClose {
    position: absolute;
    top: 20px;
    right: 20px;
    color: white;
    border: none;
    background: rgba(0,0,0,0.5);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
}


/* Immagine grande preview */
.page_chat .photoOverlayImage {
    max-width: 90vw;
    max-height: 70vh;
    object-fit: contain;
    border-radius: 8px;
}

/* Overlay per mobile */
.page_chat .photoOverlayFormMobile {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #f0f0f0;
    padding: 0.6rem;
    border-top: 1px solid #ddd;
    display: flex;
    align-items: center;
    gap: 8px;
}

/* text area mobile*/
.page_chat .photoOverlayTextareaMobile {
    flex: 1 1;
    padding: 8px;
    border-radius: 6px;
    border: 1px solid #ccc;
    resize: none;
    min-height: 40px;
}


/* Bottone freccia invio mobile */
.page_chat .photoOverlaySendButton {
    background: #e53935;
    border: none;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
}


/* Text-area per desktop */
.page_chat .photoOverlayTextareaDesktop {
    flex: 1 1;
    margin-right: 8px;
    padding: 8px;
    border-radius: 6px;
    border: 1px solid #ccc;
    min-height: 40px;
    resize: none;
}


/* 1. Forza la bolla a stringersi e a tagliare le parole */
.page_chat .chat li .chat-body,
.page_chat .chat li.right .chat-body,
.page_chat .chat li.left .chat-body {
    display: inline-block !important; /* Forza la bolla a seguire il testo */
    width: auto !important;
    min-width: 150px !important;
    max-width: 60% !important;
    box-sizing: border-box !important;

    /* TRONCAMENTO TOTALE */
    word-break: normal !important;    /* Spezza ovunque link e parole lunghe */
    overflow-wrap: break-word !important;  /* Forza il wrap in ogni caso */
    white-space: pre-wrap !important;    /* Gestisce spazi e a capo manuali */
}

/* 2. Forza il testo interno (i paragrafi) a non uscire mai */
.page_chat .chat li .chat-body p {
    margin: 0;
    word-break: normal !important;
    white-space: pre-wrap !important;
    overflow-wrap: break-word !important;
}

/* 3. Assicurati che il footer (ora/tick) non allarghi la bolla */
.page_chat .chat li .chat-body .footer_msg {
    display: flex !important;
    justify-content: flex-end !important;
    width: 100% !important;
    margin-top: 5px;
}

.page_chat .photoMsgWrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
}

.page_chat .photoMsgImage {
    width: 320px !important;
    max-width: 320px !important;
    height: auto !important;

    max-height: none !important;

    object-fit: contain;

    border-radius: 8px !important;
    cursor: pointer;

    display: block;
    margin: 0 auto;

    flex-shrink: 0 !important;
}


.page_chat .photoMsgText {
    margin-top: 10px;
    font-size: 14px;
    color: #333;
    text-align: left !important;
}

.page_chat .photoFullscreen {
    position: fixed;
    inset: 0 !important;
    width: 100vw !important;
    height: 100vh !important;

    background: rgba(0,0,0,0.9);
    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 10000;
    
}


.page_chat .photoFullscreenImg {
    width: 70vw !important;
    height: auto !important;
    max-width: none !important;
    max-height: 70vh !important;
    object-fit: contain;
    border-radius: 8px !important;
}


.page_chat .photoFullscreenClose {
    position: absolute;
    top: 20px;
    right: 20px;
    background: transparent;
    border: none;
    color: white;
    font-size: 24px;
}

.page_chat .photoPreviewForm {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;

    display: flex;
    align-items: flex-end; /* importante */
    gap: 8px;

    padding: 0.6rem;
    background: #f0f0f0;
    border-top: 1px solid #ddd;

    z-index: 10000;
}

.page_chat .photoPreviewTextarea {
    flex: 1 1;

    padding: 8px;
    border-radius: 6px;
    border: 1px solid #ccc;

    min-height: 40px;
    resize: none;
}

.page_chat .photoPreviewSend,
.page_chat .photoPreviewCancel {
    align-self: center;
    transform: translateY(-2px);
}

.page_chat .photoPreviewForm {
    padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 0.6rem);
}`, "",{"version":3,"sources":["webpack://./src/components_css/chat_content.css"],"names":[],"mappings":"AAAA;IACI,cAAc,EAAE,uCAAuC;IACvD,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;IAC3B,iCAAiC;AACrC;;AAEA,2EAA2E;AAC3E;;;IAGI,wBAAwB;IACxB,iCAAiC;IACjC,oBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,wBAAwB,EAAE,wDAAwD;AACtF;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,wEAAwE,EAAE,uCAAuC;IACjH,gBAAgB;IAChB,yBAAyB,EAAE,yCAAyC;AACxE;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,6BAA6B,EAAE,4BAA4B;IAC3D,8BAA8B,EAAE,8BAA8B;IAC9D,8BAA8B,EAAE,mCAAmC;IACnE,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;IACpB,WAAW;IACX,kCAAkC;IAClC,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,qBAAqB;IACrB,sCAAsC;IACtC,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,uCAAuC;IACvC,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,cAAc;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB,EAAE,uBAAuB;EAChD,yBAAyB,EAAE,wBAAwB;EACnD,4BAA4B,EAAE,4BAA4B;EAC1D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B,EAAE,8BAA8B;AAChE;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA,6BAA6B;AAC7B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,kCAAkC;IAClC,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;;AAGA,4BAA4B;AAC5B;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,oBAAoB;AACpB;IACI,SAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;;AAGA,iCAAiC;AACjC;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;;AAGA,0BAA0B;AAC1B;IACI,SAAO;IACP,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;AAChB;;;AAGA,0DAA0D;AAC1D;;;IAGI,gCAAgC,EAAE,sCAAsC;IACxE,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;IACzB,iCAAiC;;IAEjC,uBAAuB;IACvB,6BAA6B,KAAK,wCAAwC;IAC1E,oCAAoC,GAAG,+BAA+B;IACtE,gCAAgC,KAAK,oCAAoC;AAC7E;;AAEA,6DAA6D;AAC7D;IACI,SAAS;IACT,6BAA6B;IAC7B,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA,iEAAiE;AACjE;IACI,wBAAwB;IACxB,oCAAoC;IACpC,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;;IAEvB,2BAA2B;;IAE3B,mBAAmB;;IAEnB,6BAA6B;IAC7B,eAAe;;IAEf,cAAc;IACd,cAAc;;IAEd,yBAAyB;AAC7B;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;;IAExB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,cAAc;;AAElB;;;AAGA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,mBAAmB;IACnB,6BAA6B;AACjC;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;;IAER,aAAa;IACb,qBAAqB,EAAE,eAAe;IACtC,QAAQ;;IAER,eAAe;IACf,mBAAmB;IACnB,0BAA0B;;IAE1B,cAAc;AAClB;;AAEA;IACI,SAAO;;IAEP,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;;IAEtB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,+DAA+D;AACnE","sourcesContent":[".page_chat {\n    height: 100dvh; /* Altezza dinamica esatta per mobile */\n    display: flex !important;\n    flex-direction: column !important;\n    overflow: hidden !important;\n    box-sizing: border-box !important;\n}\n\n/* Assicura che i contenitori intermedi riempiano lo spazio senza sforare */\n.page_chat .filters-no-padding,\n.page_chat .main-chat,\n.page_chat .col-lg-12 {\n    display: flex !important;\n    flex-direction: column !important;\n    flex: 1 !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    min-height: 0 !important; /* Forza il contenitore a non espandersi oltre il flex */\n}\n\n.page_chat .chat-box {\n    position: relative !important; \n    width: 100%;\n    background: #fff;\n    border-top: 1px solid #ddd;\n    padding: 10px 0;\n    padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 15px) !important; /* Più spazio per la barra di sistema */\n    margin-top: auto; \n    flex-shrink: 0 !important; /* Impedisce alla barra di restringersi */\n}\n\n.page_chat .chat-box .form-group {\n    margin-bottom: 0 !important;\n    padding: 0 5px;\n}\n\n.page_chat #messageForm .input-group {\n    position: relative !important;\n    display: flex !important;\n    align-items: center !important;\n}\n\n.page_chat #messageForm #message {\n    padding-left: 45px !important; /* Spazio per la graffetta */\n    padding-right: 65px !important; /* Spazio per il tasto invia */\n    border-radius: 25px !important; /* Forma a pillola stile WhatsApp */\n    min-height: 45px !important;\n    line-height: 20px !important;\n    padding-top: 12px !important;\n}\n\n.page_chat .attach-button {\n    position: absolute !important;\n    left: 8px !important;\n    z-index: 10;\n    background: transparent !important;\n    border: none !important;\n    color: #666 !important;\n    width: 35px !important;\n    height: 35px !important;\n    border-radius: 50% !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    padding: 0 !important;\n    transition: background 0.2s !important;\n    top: 50% !important;\n    transform: translateY(-50%) !important;\n}\n\n.page_chat .attach-button:hover {\n    background: rgba(0,0,0,0.05) !important;\n    color: var(--primary) !important;\n}\n\n.page_chat .attach-button i {\n    font-size: 18px !important;\n}\n\n.page_chat .chat_send_button {\n    position: absolute !important;\n    right: 8px !important;\n    bottom: 5px !important;\n    height: 35px !important;\n    padding: 0 15px !important;\n    border-radius: 20px !important;\n    z-index: 10;\n}\n\n.page_chat #chatArea {\n    flex: 1;\n    overflow-y: auto;\n    padding-bottom: 10px !important;\n}\n\n.page_chat .spacerMsg {\n    height: 50px;\n}\n\n.page_chat .photo-placeholder,\n.page_chat img {\n    width: 300px;\n    display: block;\n}\n\n.page_chat .chat-box {\n  transition: all 0.2s ease;\n}\n\n.page_chat .chat-box.photo-mode .chat_send_button {\n  padding: 6px 10px;\n  font-size: 12px;\n}\n\n.page_chat .chat-box.photo-mode .input-group {\n  display: flex !important;\n  align-items: center !important;\n  height: 40px !important;\n}\n\n.page_chat .chat-box.photo-mode .attach-button,\n.page_chat .chat-box.photo-mode .input-group-append button {\n  height: 26px !important; /* Adjusted from 20px */\n  padding: 0 8px !important; /* Reduced from 0 10px */\n  line-height: 26px !important; /* Updated to match height */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 15px !important; /* Added for rounded corners */\n}\n\n.page_chat .chat-box.photo-mode textarea {\n  height: 26px !important;\n  min-height: 26px !important;\n  max-height: 26px !important;\n  padding: 2px 6px !important;\n  font-size: 11px;\n  resize: none !important;\n  overflow: hidden;\n}\n\n.page_chat .chat-box.photo-mode .input-group > * {\n  align-self: center;\n}\n\n\n/* Overlay immagine preview */\n.page_chat .photoOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0,0,0,0.85);\n    z-index: 10000;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem;\n}\n\n/* Pulsante chiusura preview */\n.page_chat .photoOverlayClose {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    color: white;\n    border: none;\n    background: rgba(0,0,0,0.5);\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n\n/* Immagine grande preview */\n.page_chat .photoOverlayImage {\n    max-width: 90vw;\n    max-height: 70vh;\n    object-fit: contain;\n    border-radius: 8px;\n}\n\n/* Overlay per mobile */\n.page_chat .photoOverlayFormMobile {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    background: #f0f0f0;\n    padding: 0.6rem;\n    border-top: 1px solid #ddd;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n/* text area mobile*/\n.page_chat .photoOverlayTextareaMobile {\n    flex: 1;\n    padding: 8px;\n    border-radius: 6px;\n    border: 1px solid #ccc;\n    resize: none;\n    min-height: 40px;\n}\n\n\n/* Bottone freccia invio mobile */\n.page_chat .photoOverlaySendButton {\n    background: #e53935;\n    border: none;\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n}\n\n\n/* Text-area per desktop */\n.page_chat .photoOverlayTextareaDesktop {\n    flex: 1;\n    margin-right: 8px;\n    padding: 8px;\n    border-radius: 6px;\n    border: 1px solid #ccc;\n    min-height: 40px;\n    resize: none;\n}\n\n\n/* 1. Forza la bolla a stringersi e a tagliare le parole */\n.page_chat .chat li .chat-body,\n.page_chat .chat li.right .chat-body,\n.page_chat .chat li.left .chat-body {\n    display: inline-block !important; /* Forza la bolla a seguire il testo */\n    width: auto !important;\n    min-width: 150px !important;\n    max-width: 60% !important;\n    box-sizing: border-box !important;\n\n    /* TRONCAMENTO TOTALE */\n    word-break: normal !important;    /* Spezza ovunque link e parole lunghe */\n    overflow-wrap: break-word !important;  /* Forza il wrap in ogni caso */\n    white-space: pre-wrap !important;    /* Gestisce spazi e a capo manuali */\n}\n\n/* 2. Forza il testo interno (i paragrafi) a non uscire mai */\n.page_chat .chat li .chat-body p {\n    margin: 0;\n    word-break: normal !important;\n    white-space: pre-wrap !important;\n    overflow-wrap: break-word !important;\n}\n\n/* 3. Assicurati che il footer (ora/tick) non allarghi la bolla */\n.page_chat .chat li .chat-body .footer_msg {\n    display: flex !important;\n    justify-content: flex-end !important;\n    width: 100% !important;\n    margin-top: 5px;\n}\n\n.page_chat .photoMsgWrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n}\n\n.page_chat .photoMsgImage {\n    width: 320px !important;\n    max-width: 320px !important;\n    height: auto !important;\n\n    max-height: none !important;\n\n    object-fit: contain;\n\n    border-radius: 8px !important;\n    cursor: pointer;\n\n    display: block;\n    margin: 0 auto;\n\n    flex-shrink: 0 !important;\n}\n\n\n.page_chat .photoMsgText {\n    margin-top: 10px;\n    font-size: 14px;\n    color: #333;\n    text-align: left !important;\n}\n\n.page_chat .photoFullscreen {\n    position: fixed;\n    inset: 0 !important;\n    width: 100vw !important;\n    height: 100vh !important;\n\n    background: rgba(0,0,0,0.9);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    z-index: 10000;\n    \n}\n\n\n.page_chat .photoFullscreenImg {\n    width: 70vw !important;\n    height: auto !important;\n    max-width: none !important;\n    max-height: 70vh !important;\n    object-fit: contain;\n    border-radius: 8px !important;\n}\n\n\n.page_chat .photoFullscreenClose {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    background: transparent;\n    border: none;\n    color: white;\n    font-size: 24px;\n}\n\n.page_chat .photoPreviewForm {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n\n    display: flex;\n    align-items: flex-end; /* importante */\n    gap: 8px;\n\n    padding: 0.6rem;\n    background: #f0f0f0;\n    border-top: 1px solid #ddd;\n\n    z-index: 10000;\n}\n\n.page_chat .photoPreviewTextarea {\n    flex: 1;\n\n    padding: 8px;\n    border-radius: 6px;\n    border: 1px solid #ccc;\n\n    min-height: 40px;\n    resize: none;\n}\n\n.page_chat .photoPreviewSend,\n.page_chat .photoPreviewCancel {\n    align-self: center;\n    transform: translateY(-2px);\n}\n\n.page_chat .photoPreviewForm {\n    padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 0.6rem);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
